export type RegionView = {
  center: [number, number];
  zoom: number;
};

export const REGION_VIEWS: Record<string, RegionView> = {
  VIETNAM: { center: [16.0, 106.0], zoom: 6 },
  GB: { center: [54.0, -2.0], zoom: 6 },
  CHINA: { center: [35.0, 105.0], zoom: 4 },
};

const DEFAULT_VIEW: RegionView = { center: [16.0, 106.0], zoom: 6 };

export const getRegionView = (regionCode: string): RegionView =>
  REGION_VIEWS[regionCode] ?? DEFAULT_VIEW;

export const filterSalonsWithCoords = <
  T extends { lat: number | null; lon: number | null },
>(
  salons: T[]
): Array<T & { lat: number; lon: number }> =>
  salons.filter(
    (salon): salon is T & { lat: number; lon: number } =>
      salon.lat != null && salon.lon != null
  );
